/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHexagon: {
  name: 'hexagon';
  data: string;
} = {
  name: 'hexagon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.33.776a1.5 1.5 0 0 1 1.34 0l5 2.5a1.5 1.5 0 0 1 .83 1.342v6.764a1.5 1.5 0 0 1-.83 1.342l-5 2.5a1.5 1.5 0 0 1-1.34 0l-5-2.5a1.5 1.5 0 0 1-.83-1.342V4.618a1.5 1.5 0 0 1 .83-1.342l5-2.5Zm.894.895a.5.5 0 0 0-.448 0l-5 2.5a.5.5 0 0 0-.276.447v6.764a.5.5 0 0 0 .276.447l5 2.5a.5.5 0 0 0 .448 0l5-2.5a.5.5 0 0 0 .276-.447V4.618a.5.5 0 0 0-.276-.447l-5-2.5Z" fill="currentColor"/></svg>`,
};
